import { Trans } from '@lingui/react/macro'
import { Box, Button, Card, Group, rem, Stack, Text } from '@mantine/core'
import { IconArrowRight, IconSparkles } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'

interface MarkkuSavingsCardProps {
  propertyId: number
}

export function MarkkuSavingsCard({ propertyId }: MarkkuSavingsCardProps) {
  // Mock data - would come from API
  const savedHours = 20
  const savedTasks = 30

  return (
    <Card
      radius="lg"
      withBorder
      p="md"
      style={{
        background: 'linear-gradient(135deg, #FFF4EC 0%, #FFE8D8 100%)',
        borderColor: 'var(--mantine-color-orange-2)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Subtle background decoration */}
      <Box
        style={{
          position: 'absolute',
          top: -30,
          right: -30,
          width: rem(100),
          height: rem(100),
          borderRadius: '50%',
          background: 'rgba(255, 139, 52, 0.08)',
        }}
      />

      <Stack gap="sm" style={{ position: 'relative' }}>
        <Stack gap={4}>
          <Group gap="xs">
            <IconSparkles size={20} color="var(--mantine-color-orange-6)" />
            <Text size="md" fw={600} c="gray.8">
              <Trans>Less worry, more time</Trans>
            </Text>
          </Group>
          <Text size="xs" c="gray.6">
            <Trans>
              With the Markku package, you save {savedHours}h per year and{' '}
              {savedTasks} maintenance tasks
            </Trans>
          </Text>
        </Stack>

        <Button
          size="md"
          radius="md"
          variant="filled"
          color="brandOrange"
          to={`/properties/${propertyId}?tab=package`}
          component={Link}
          rightSection={<IconArrowRight size={18} />}
          fullWidth
        >
          <Trans>Explore packages</Trans>
        </Button>
      </Stack>
    </Card>
  )
}
